import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router } from 'react-router-dom';

// Styles
import './assets/fonts/fonts.css';
import GlobalStyles from './GlobalStyles';

import App from './App';

ReactDOM.render(
  <Router>
    <GlobalStyles />
    <App />
  </Router>,

  document.querySelector('#react-root')
);
